import React from 'react';
import { useAppMode } from '../contexts/AppModeContext';
import UserProfilePage from './UserProfilePage';
import JobProfilePage from './JobProfilePage';

const ProfileRouter: React.FC = () => {
  const { is_job } = useAppMode();
  return is_job ? <JobProfilePage /> : <UserProfilePage />;
};

export default ProfileRouter;


